var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLock = function SvgLock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.734 10.98-.056-2.845C17.678 5.852 15.626 4 13.096 4h-2.08c-2.53 0-4.582 1.852-4.582 4.135l.028 2.845h-.169C5.59 10.98 5 11.487 5 12.147v7.686C5 20.467 5.562 21 6.293 21h11.413c.703 0 1.293-.507 1.293-1.167v-7.686c.028-.66-.562-1.167-1.265-1.167m-5.706 6.113c-.675 0-1.237-.507-1.237-1.116s.562-1.116 1.237-1.116c.674 0 1.236.507 1.236 1.116s-.562 1.116-1.236 1.116M7.446 10.98l-.028-2.896c0-1.7 1.546-3.095 3.429-3.095h2.418c1.883 0 3.429 1.396 3.429 3.095l.028 2.896z"
  })));
};
export { SvgLock as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.8fabc0968c23006eeaff303c72c905bd.svg";